module.exports = __webpack_public_path__ + "media/birthday_tier_1-fadf20721d2a1ff64b319910f85565c3.mp3";